<template>	
	<div class="knd-dropdown">
		<div 
			class="knd-dropdown-button" 
			@click="dropdownClicked()" 
			ref="knd-dropdown"
			:class="{ clicked: isOpen, chosen: chosen }" >

			<div 
				class="knd-dropdown-text" 
				v-html="text"
				v-if="!dropdowntext"></div>

			<div 
				class="knd-dropdown-text" 
				v-html="dropdowntext"
				v-if="dropdowntext"></div>

			<svg class="knd-dropdown-icon" width="67" height="67" viewBox="0 0 67 67" fill="none" xmlns="http://www.w3.org/2000/svg">
				<defs>
					<mask id="arrowMask">
						<circle cx="33" cy="33" r="33" fill="white" />
						<path d="M31.7692 44.0488L31.7692 20L35.2308 20L35.2308 44.0488C36.0615 41.9268 37.4462 40.0642 39.3846 38.461C41.3231 36.8577 43.8615 35.8911 47 35.561L47 39.0976C44.0923 39.4276 41.6 40.5594 39.5231 42.4927C37.4462 44.4732 36.0154 46.6423 35.2308 49L31.7692 49C30.9846 46.6423 29.5538 44.4732 27.4769 42.4927C25.4 40.5593 22.9077 39.4276 20 39.0976L20 35.561C23.1385 35.8911 25.6769 36.8577 27.6154 38.461C29.5538 40.0642 30.9385 41.9268 31.7692 44.0488Z" fill="black"/>
					</mask>
				</defs>
				<circle class="knd-dropdown-icon-background" cx="33" cy="33" r="33" mask="url(#arrowMask)" />
			</svg>
		</div>

		<div 
			class="knd-dropdown-options" 
			ref="knd-dropdown-options"
			:class="{ visible: isOpen }">
			<div
				v-for="(option, index) in options" 
				:key="'option-' + index"
				class="knd-dropdown-option"
				@click="optionClicked(option, index)">
				<div class="dropdown-name">{{ option["label"] }}</div>
			</div>
		</div>
	</div>
</template>

<script>

	export default {
		name: 'Dropdown',
		props: {
			options: {
				type: Array,
				default: () => []
			},
			text: {
				type: String,
				default: "Selecteer..."
			},
			dropdownFn:Function
		},
		data: function() {
			return {
				dropdowntext: null,
				isOpen: false,
				chosen: false
			}
		},
		mounted() {
		},
		methods: {
			dropdownClicked() {
				this.isOpen = !this.isOpen;
			},

			optionClicked(option, index) {
				this.isOpen = false;
				this.chosen = true;

				this.dropdowntext = '<div class="dropdown-name">' + option["label"] + '</div>'

				this.dropdownFn(option);
			}
		}
	}
</script>

<style lang="scss">

	$knd-dropdown-color: var(--knd-dropdown-color, #2a3700);
	$knd-dropdown-highlight: var(--knd-dropdown-highlight, #E3FFA1);
	$knd-dropdown-highlight-text: var(--knd-dropdown-highlight-text, #000);
	$knd-dropdown-bg: var(--knd-dropdown-bg, #FFF);

	.knd-dropdown {
		position: relative;
		width: 100%;
		max-width: 400px;
		margin: 50px auto;

		.knd-dropdown-button {
			position: relative;
			width: 100%;
			height: 50px;
			border: 1px solid $knd-dropdown-color;
			border-radius: 25px;
			padding: 10px 20px;
			cursor: pointer;
			background: $knd-dropdown-bg;

			.knd-dropdown-text {
				display: flex;
				align-items: center;
				justify-content: left;
				color: $knd-dropdown-color;

				.dropdown-index {
					margin-top: 5px;
				}

				.dropdown-name {
					margin-top: 5px;
				}
			}

			.knd-dropdown-icon {
				position: absolute;
				top: 5px;
				right: 5px;
				pointer-events: none;
				width: 38px;
				height: 38px;

				.knd-dropdown-icon-background {
					fill: $knd-dropdown-color;
				}
			}

			&.clicked {
				border-bottom-right-radius: 0px;
				border-bottom-left-radius: 0px;
			}

			&.chosen {
				background-color: $knd-dropdown-highlight;
				text-align: left;

				.knd-dropdown-text {
					color: $knd-dropdown-highlight-text;
				}

				.knd-dropdown-icon {
					.knd-dropdown-icon-background {
						fill: $knd-dropdown-highlight-text;
					}
				}
			}
		}

		.knd-dropdown-options {
			position: relative;
			border: 1px solid $knd-dropdown-color;
			padding: 10px;
			box-sizing: border-box;
			overflow: hidden;
			margin-top: -1px;
			display: none;
			color: $knd-dropdown-color;
			background: $knd-dropdown-bg;

			.knd-dropdown-option {
				position: relative;
				width: 100%;
				height: 50px;
				border: 1px solid $knd-dropdown-color;
				border-radius: 25px;
				padding: 10px 20px;
				margin: 5px 0px;
				cursor: pointer;
				display: flex;
				align-items: center;
				justify-content: left;
			}

			&.visible {
				display: block;
			}
		}

		.dropdown-index {
			height: 40px;
			margin-top: 20px;
			font-family: 'PPFormulaCondensed',"Times New Roman",serif;
			font-size: 1.6em;
			line-height: 1em;
			margin-right: 10px;
		}

		.dropdown-name {
			height: 40px;
			margin-top: 20px;
			line-height: 1em;
		}
		
	}


</style>